import React, { useEffect } from 'react'
import I18n from "lib/i18n/i18n"
import { useSelector } from "react-redux"
import Login from "../login"
import CallDetails from "./callDetails"
import UserActions from "lib/userActions"
import ManageCallSkeleton from "./manageCallSkeleton";
import { useAppointment } from "../../hooks/useAppointment"
import CalendlyHelper from "../../lib/calendly";


const ManageCallMain = (props) => {

    const { Session, ADO } = useSelector(state => state)
    const { data, isLoading, error }  = useAppointment(ADO?.user?.id)

    useEffect(() => {
        logAction('Page presented')
        CalendlyHelper.loadCalendly()

    }, [])

    const logAction = (message) => {
        UserActions.manageCallPage(`${data ? data.objectType + ' ' : '' }Manage Call - ${message}`)
    }

    const pageBlocked = () => {
        return !data || error || props.canceled
    }

    const showDetails = () => {
        return data?.objectType !== 'Jewelry Box'
    }

    return (
        Session?.isLoggedIn ? isLoading ? <ManageCallSkeleton /> :
            <div className={'manage-call-wrapper'}>
                <div className={'title'}>{data?.appointmentId || pageBlocked() ? I18n.getString('manageCall::title::reschedule') : I18n.getString('manageCall::title::schedule')}</div>
                {
                    !pageBlocked() && <div className={'wrapper'}>
                        <div className={'regarding'}>{ showDetails() ? I18n.getString('manageCall::regarding') : ''}</div>
                        <div className={'desc'}>{ showDetails() ? data?.objectDesc : '' }</div>
                        <div className={'id'}>{ showDetails() ? `#${ data?.objectId }` : '' }</div>
                    </div>
                }
                < CallDetails logger={logAction} pageBlocked={pageBlocked} pageMode={data && data.appointmentId ? 'reschedule' : 'schedule'} />
            </div>
        : <Login
            onLoginSuccessful={() => {}}
            showLinkToRegister={true} />
    )
}

export default ManageCallMain
